import landlord from "../../../assets/images/Home.landlord.png";
import tenant from "../../../assets/images/Home.tenant.png";
import HomeLine2 from "../../../assets/images/Home.line2.svg";
import Individual from "../../../assets/images/Home.Individual.png";
import line from "../../../assets/images/Home.Line.png";
import laptop from "../../../assets/images/Home.Business.MacBook Pro 16.svg";
import flow from "../../../assets/images/Home.Flow.svg";
import phone from "../../../assets/images/Home.Phone.PNG";
import solutionLandlord from "../../../assets/images/Home.solution.Landlord.svg";
import line2 from "../../../assets/images/Home.Tenant.Line 2.svg";
import tenantfeature1 from "../../../assets/images/Tenant.feature1.svg";
import tenantfeature2 from "../../../assets/images/Tenant.feature2.svg";
import tenantfeature3 from "../../../assets/images/Tenant.feature3.svg";
import tenantfeature4 from "../../../assets/images/Tenant.feature4.svg";
import line3 from "../../../assets/images/Home.Individual.Line 2.svg";
import AutomateReciept from "../../../assets/images/HomeScreen/Home.automated.reciept.svg";
import OnlinePayment from "../../../assets/images/HomeScreen/Home.Online.Payment.svg";
import Inquiries from "../../../assets/images/HomeScreen/Home.queries.svg";
import Analytics from "../../../assets/images/HomeScreen/Home.Analytics.svg";
import Onboarding from "../../../assets/images/HomeScreen/Home.onboarding.svg";
import complaint from "../../../assets/images/HomeScreen/Home.Online.Complaints.svg";
import kyc from "../../../assets/images/HomeScreen/Home.Digital.Kyc.svg";
import paymentReminder from "../../../assets/images/HomeScreen/Home.payment.Reminder.svg";
import complaintAssignment from "../../../assets/images/HomeScreen/Home.complaint.Assignment.svg";
import property from "../../../assets/images/HomeScreen/Home.property.listing.svg";
import individualfeature1 from "../../../assets/images/Individual.feature1.svg";
import individualfeature2 from "../../../assets/images/Individual.feature2.svg";
import individualfeature3 from "../../../assets/images/Individual.feature3.svg";
import individualfeature4 from "../../../assets/images/Individual.feature4.svg";
import getStarted from "../../../assets/images/Home.ButtonStarted.svg";
import jobUpload from "../Job.Upload.svg";

import laptopImg from "../laptopImg.png";
import img1 from "../HomeScreen/Property 1=Default-1.png";
import img2 from "../HomeScreen/Property 1=Default-2.png";
import img3 from "../HomeScreen/Property 1=Default-3.png";
import img4 from "../HomeScreen/Property 1=Default-4.png";
import img5 from "../HomeScreen/Property 1=Default-5.png";
import img6 from "../HomeScreen/Property 1=Default-6.png";
import img7 from "../HomeScreen/Property 1=Default-7.png";
import img8 from "../HomeScreen/Property 1=Default-8.png";
import img9 from "../HomeScreen/Property 1=Default-9.png";
// import img10 from "../HomeScreen/Property 1=Default-10.png";
import img from "../HomeScreen/Property 1=Default.png";

import tenantScreenBg from "../tenantScreenBg.png";
export const Images = {
  landlord,
  tenant,
  Individual,
  line,
  HomeLine2,
  laptop,
  flow,
  phone,
  solutionLandlord,
  line2,
  tenantfeature1,
  tenantfeature2,
  tenantfeature3,
  tenantfeature4,
  line3,
  AutomateReciept,
  OnlinePayment,
  Inquiries,
  Analytics,
  Onboarding,
  complaint,
  kyc,
  jobUpload,
  paymentReminder,
  complaintAssignment,
  property,
  individualfeature1,
  individualfeature2,
  individualfeature3,
  individualfeature4,
  getStarted,
  laptopImg,
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  // img10,
  img,
  tenantScreenBg,
};
